<template>
    <div class="contentCenter help-wrapper">
        <!-- 樹照片 -->
        <div class="imgBox">
            <img :src="imgUrl" alt="tree" class="imgStyle">
        </div>
        <!-- 我的固碳能力 -->
        <div class="content-wrapper">
            <div class="treeTitle orange">
                我的固碳能力
            </div>
            <div class="textBox">
                <p>{{ ability.content }}</p>
                <span class="additional" v-if="ability.additional">{{ ability.additional }}</span>
            </div>
        </div>
        <!-- 樹種名稱 -->
        <div class="content-wrapper">
            <div class="treeTitle">
                樹種名稱
            </div>
            <div class="textBox">
                {{ treeType }}
            </div>
        </div>
        <!-- 性狀分類 -->
        <div class="content-wrapper">
            <div class="treeTitle">
                性狀分類
            </div>
            <div class="textBox">
                {{ category }}
            </div>
        </div>
        <!-- 樹木簡介 -->
        <div class="content-wrapper">
            <div class="treeTitle">
                樹木簡介
            </div>
            <div class="textBox">
                {{ introduction }}
            </div>
        </div>
    </div>
</template>
<script>
/* eslint-disable global-require */

export default {
    data() {
        return {
        };
    },
    props: {
        imgUrl: {
            type: String,
            require: false,
        },
        ability: {
            type: String,
            require: false,
        },
        treeType: {
            type: String,
            require: false,
        },
        category: {
            type: String,
            require: false,
        },
        introduction: {
            type: String,
            require: false,
        },
    },
};
</script>

<style lang="sass" scoped>
.help-wrapper
    padding: 0 16px

.imgBox
    border: 3px solid #fff
    width: 100%

    .imgStyle
        width: 100%
        height: 100%
.content-wrapper
    width: 100%

    %padding
        padding: 4px 16px
    .treeTitle
        @extend %padding
        width: 100%
        border: 1px solid rgba(121, 121, 121, 1)
        background-color: #b0cf72
        color: #fff
        border-radius: 6px
        font-size: 0.875rem
        font-weight: 600
    .orange
        background-color: rgb(245, 154, 35)

    .textBox
        @extend %padding
        background-color: #fff
        border: 1px solid rgba(121, 121, 121, 1)
        border-top: none
        border-bottom-right-radius: 6px
        border-bottom-left-radius: 6px
        font-size: 13px
        p
            margin-block-end: auto
        .additional
            color: #999
</style>
